import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";

const Region = Loadable({
  loader: () => import("container/management/region"),
  loading() {
    return <Loader />;
  }
});

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_region" }
];

export const regionRoutes = [
  {
    path: "/management/region",
    element: <Region />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
